module.exports = __webpack_public_path__ + "94244671cdc100ed6313c27df6373f20.mp3";